var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8008 17.4462V14.9836C11.8008 10.9079 13.0008 7.5957 19.0008 7.5957C25.0008 7.5957 26.2008 10.9079 26.2008 14.9836V17.4462",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24.8342C22 26.5334 20.656 27.9124 19 27.9124C17.344 27.9124 16 26.5334 16 24.8342C16 23.1349 17.344 21.7559 19 21.7559C20.656 21.7559 22 23.1349 22 24.8342Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32.2219H13C8.2 32.2219 7 30.9905 7 26.0653V23.6026C7 18.6774 8.2 17.446 13 17.446H25C29.8 17.446 31 18.6774 31 23.6026V26.0653C31 30.9905 29.8 32.2219 25 32.2219Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/Secure.fb8934208e302dc4aaeee90ed213a5a4.svg";
export { ForwardRef as ReactComponent };